import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sortSizes } from '../../../lib/utils/utils';
import { setActiveImageList, setActiveImageUrl, setActiveSize, setSizeList } from '../../../Features/inventoryManagementSlice';

function ProductImages() {
    const dispatch = useDispatch();
    const imageContainerRef = useRef(null);
    const mainImageRef = useRef(null);

    const activeProduct = useSelector((state) => state.inventoryManagement.activeProduct.activeProduct);
    const { activeColorVariant: { activeImageList }, activeImageUrl } = useSelector((state) => state.inventoryManagement.variantInfo);

    const [mediaContainerHeight, setMediaContainerHeight] = useState(0);
    const [showZoom, setShowZoom] = useState(false);
    const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
    const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');

    function handleSetImageUrl(url) {
        dispatch(setActiveImageUrl(url));
    }

    const handleMouseMove = (e) => {
        if (!mainImageRef.current) return;

        const rect = mainImageRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Calculate percentage position
        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        setZoomPosition({ x, y });
        setBackgroundPosition(`${xPercent}% ${yPercent}%`);
    };

    const handleMouseEnter = () => {
        setShowZoom(true);
    };

    const handleMouseLeave = () => {
        setShowZoom(false);
    };

    useEffect(() => {
        if(imageContainerRef.current) {
            setMediaContainerHeight(imageContainerRef.current.clientWidth);
        }
    }, [imageContainerRef]);

    useEffect(() => {
        if(Object.keys(activeProduct).length > 0) {
            const colorVariant = {
                activeImageList: activeProduct.product.productImgUrls,
                color: activeProduct.product.productSpecs.color,
            }
            dispatch(setActiveSize(activeProduct.product.productSpecs.size));
            dispatch(setActiveImageList(colorVariant));
            dispatch(setActiveImageUrl(activeProduct.product.productImgUrls[0]));

            if(activeProduct.variety.length > 0) {
                let sizeList = activeProduct.variety.map(variety => variety.VarientSize);
                let sortedList = sortSizes([...new Set(sizeList)]);
                dispatch(setSizeList(sortedList));
            }
            else {
                let sizeList = [activeProduct.product.productSpecs.size];
                dispatch(setSizeList(sizeList));
            }
        }
    }, [activeProduct]);

    return (
        <div className='w-[37%] flex flex-col gap-2 select-none'>
            <div className="relative">
                <div 
                    ref={imageContainerRef} 
                    className="flex items-center justify-center w-full rounded-2xl overflow-hidden relative"
                    style={{ height: `${mediaContainerHeight}px` }}
                    onMouseMove={handleMouseMove}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <img 
                        ref={mainImageRef}
                        className='max-w-full max-h-full' 
                        src={activeImageUrl} 
                        alt="" 
                    />
                </div>

                {/* Zoomed View - Shows on the right side */}
                {showZoom && (
                    <div 
                        className="absolute top-0 left-[calc(100%+16px)] w-full h-full rounded-2xl border-2 border-gray-200 bg-white overflow-hidden shadow-lg z-10"
                        style={{ height: `${mediaContainerHeight}px` }}
                    >
                        <div
                            className="w-full h-full"
                            style={{
                                backgroundImage: `url(${activeImageUrl})`,
                                backgroundSize: '250%',
                                backgroundPosition: backgroundPosition,
                                backgroundRepeat: 'no-repeat'
                            }}
                        />
                    </div>
                )}
            </div>

            <div className="flex flex-wrap gap-2">
                {activeImageList?.map((image, index) => {
                    return (
                        <div 
                            key={index} 
                            onClick={() => handleSetImageUrl(image)} 
                            className={`size-[100px] rounded-lg overflow-hidden bg-[#333333] ${
                                activeImageUrl === image ? 'ring-2 ring-blue-500' : ''
                            }`}
                        >
                            <img 
                                className='size-full object-cover hover:opacity-85 cursor-pointer' 
                                src={image} 
                                alt="" 
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ProductImages;
